import React, { useEffect, useReducer } from "react";
import { Navigate } from "react-router-dom";
import { isLoggedInUserTreeAdminFromStorage } from "../../Utils/subscriptionAccess";

export default function AdminInstruction() {
  const [, rerender] = useReducer((n) => n + 1, 0);
  useEffect(() => {
    const bump = () => rerender();
    window.addEventListener("loggedInUserRoleUpdated", bump);
    window.addEventListener("localStorageChange", bump);
    window.addEventListener("focus", bump);
    return () => {
      window.removeEventListener("loggedInUserRoleUpdated", bump);
      window.removeEventListener("localStorageChange", bump);
      window.removeEventListener("focus", bump);
    };
  }, []);

  if (!isLoggedInUserTreeAdminFromStorage()) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="RightSideDiv">
      <div className="right-top">
        <h2 style={{ margin: 0, fontWeight: 600 }}>Admin instruction</h2>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div
          style={{
            width: '100%',
            maxWidth: '700px',
            border: '1px solid #dbdbdb',
            borderRadius: '10px',
            padding: '2rem',
            backgroundColor: '#fff',
            lineHeight: 1.6,
          }}
        >
          <p style={{ marginTop: 0 }}>
            Guidance for family administrators will appear here. Use this space for policies,
            onboarding steps, or links your admins should follow.
          </p>
        </div>
      </div>
    </div>
  );
}
